"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WbfMembershipEmailDomains = void 0;
var WbfMembershipEmailDomains;
(function (WbfMembershipEmailDomains) {
    WbfMembershipEmailDomains["AutomationUnion360"] = "810f3e01-ce27-4780-8982-b45d3a3d9664";
    WbfMembershipEmailDomains["BCF_HELP"] = "d32ed244-5433-47f0-8926-ceb06bfa18fe";
})(WbfMembershipEmailDomains || (exports.WbfMembershipEmailDomains = WbfMembershipEmailDomains = {}));
//# sourceMappingURL=wbf-membership-email-domains.js.map